/* eslint-disable import/prefer-default-export */
import { Resolver } from '../../config';
import { ChainType } from '../../providers/GatekeeperNetworkService/GatekeeperNetworkServiceData';

export type WalletBalanceResult = {
  wallet: string;
  chain: string;
  balance: string;
  error?: string;
};

const chainParamMapping = (chain: ChainType): string => {
  if (chain === 'ethereum') {
    return 'eth';
  }
  return chain;
};
/**
 * https://zqsngqkyo1.execute-api.us-east-1.amazonaws.com/?wallet=0x9b4525aefEDA97b78559012ddA8163eF90B3dF21&chain=eth-1
 * @param config
 * @param walletAddress
 * @param chainId
 */
export const getWalletBalance = async (
  walletAddress: string,
  chain: ChainType,
  chainId: string,
): Promise<WalletBalanceResult> => {
  const serviceConfig = Resolver.getServiceConfig();
  const { endpoint } = serviceConfig.walletBalanceService;
  const url = new URL(`${endpoint}`);
  url.searchParams.append('wallet', walletAddress);
  url.searchParams.append('chain', `${chainParamMapping(chain)}-${chainId}`);
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': `${process.env.REACT_APP_WALLET_BALANCE_API_KEY}`,
    },
  });
  const result = (await response.json()) as WalletBalanceResult;
  return result;
};
